
import dot from "dot";

let tpl_general = require("./tpl_general.html");
let tpl_myquestion = require("./tpl_myquestion.html");
let tpl_special = require("./tpl_special.html")
let tpl_guest_lk = require("./tpl_guests_lk.html")
let tpl_presenter_lk = require("./tpl_presenter_lk.html")

import { formatGenerallist, formatSpeciallist, formatPresenterlistLK, formatGuestlistLK } from "./formatdata"


interface obj {
  data: any,  // 列表数据
  isSpecialStatus: boolean,  // 身份信息
  guestsId: Array<any>, //嘉宾
  presentersId: Array<any>,   // 主持人
  isLangKeRoom: boolean,  // 是否是浪客直播间
  userIsGuest: boolean, // 是否是嘉宾
  userIsPresenter: boolean  // 是否是主持人
  isAdmin: boolean // 是否是嘉宾或主持人(url 参数判断)
};


export default function getChatDomList(this: any, obj: obj) {
  let that = this;
  let htmlstr = "";
  let userIsPresenter = obj.userIsPresenter;

  let { isAdmin, userIsGuest, isLangKeRoom } = obj

  // console.log(obj)

  // 非浪客嘉宾和主持人
  if (!isLangKeRoom && that.isSpecialStatus && isAdmin) {
    let list = formatSpeciallist(that, obj);
    htmlstr = dot.template(tpl_special)(list);
  };

  // 浪客直播嘉宾或主持人
  if (isLangKeRoom && that.isSpecialStatus && isAdmin) {
    // 嘉宾
    if (userIsGuest) {
      let list = formatGuestlistLK(that, obj);
      htmlstr = dot.template(tpl_guest_lk)(list);
    }
    // 主持人
    else {
      if (that.type == 0) {
        $(".paifaAll").show()
      } else {
        $(".paifaAll").hide()
      };
      let list = formatPresenterlistLK(that, obj);
      htmlstr = dot.template(tpl_presenter_lk)(list);
    }
  };

  // 普通用户
  if (!that.isSpecialStatus || !isAdmin) {
    let list = formatGenerallist(that, obj);

    console.log(list)

    // 全部
    if (that.type === 0) {
      htmlstr = dot.template(tpl_general)(list);
    }

    // 我的提问
    if (that.type === 1) {
      htmlstr = dot.template(tpl_myquestion)(list);
    };
  };

  return htmlstr;

};